{
  "about": {
    "paragraph": "Estamos comprometidos em enfrentar os desafios da lei AGEC e informar nossos clientes sobre a origem e as qualidades ambientais dos nossos produtos.",
    "title": "Sobre"
  },
  "lastUpdate": "Data da última atualização : ",
  "loading": {
    "dataPending": "está atualmente a recolher esta informação",
    "pendingLocation": "Localização pendente"
  },
  "activities": {
    "APPAREL_MANUFACTURING": "Fabricação de vestuário",
    "FOOTWEAR_FINISHING": "Acabamento de calçado",
    "FOOTWEAR_STITCHING": "Costura de calçado",
    "FOOTWEAR_ASSEMBLING": "Montagem de calçado",
    "FABRIC_WEAVING_OR_KNITTING": "Tecelagem ou malharia",
    "FABRIC_DYEING_PRINTING": "Tinturaria ou estampagem de tecidos",
    "YARN_PROVIDER": "Fornecedor de fio",
    "YARN_DYEING_PRINTING": "Tinturaria ou estampagem de fio",
    "LEATHER_TANNING": "Curtimento do couro",
    "LEATHER_DYEING_PRINTING": "Tinturaria ou estampagem do couro",
    "ACCESSORY_PROVIDER": "Fornecedor de acessórios",
    "YARN_MATERIAL_PRODUCTION": "Produção de material de fio",
    "FABRIC_SPINNING": "Fiação de tecido",
    "FABRIC_MATERIAL_PRODUCTION": "Produção de material de tecido",
    "LEATHER_MATERIAL_PRODUCTION": "Produção de material de couro",
    "LEATHER_FARM": "Fazenda de criação",
    "ACCESSORY_RAW_MATERIAL_PROVIDER": "Fornecedor de matéria-prima de acessórios",
    "COATING": "Revestimento"
  },
  "other": {
    "microplastics_bold": "liberta microplásticos ",
    "paragraph1": "Este produto contém ",
    "paragraph1_100": "Este produto contém 100% de materiais reciclados.",
    "paragraph2_1": "Este produto ",
    "paragraph2_2": "  no ambiente durante a lavagem: ",
    "paragraph2_3": "por massa do produto é composto por fibras sintéticas.",
    "paragraph3": "Informações sobre a potencial presença de substâncias perigosas na aplicação: ",
    "recycled_matertials_bold": "pelo menos {{percent}}% de materiais reciclados.",
    "recycled_matertials_bold_50": "mais de 50% ",
    "title": "Outras qualidades e características ambientais"
  },
  "packaging": {
    "recyclable": "Reciclável: A embalagem é reciclável.",
    "recycled": "Materiais reciclados: A embalagem contém pelo menos {{percent}}% de materiais reciclados.",
    "recycled_100": "Materiais reciclados: A embalagem contém 100% de materiais reciclados.",
    "title": "Qualidades e características ambientais da embalagem"
  },
  "title": "Ficha do produto sobre qualidades ou características ambientais",
  "traceability": {
    "paragraph": "Refere-se à origem do seu produto nas suas três primeiras etapas de produção, desde a sua criação até à tecelagem e tingimento do seu material principal.",
    "title": "Rastreabilidade do produto"
  },
  "ecoScore": {
    "title": "EcoScore",
    "b2b": "Custo ambiental : {{cost}} pontos de impacto"
  }
}
